const FILES_ACTION = {
  DOWNLOADED: 'FILES_DOWNLOADED',
  DELETE_ITEM: 'FILES_DELETE_ITEM',
  DELETE_UNUSED: 'FILES_DELETE_UNUSED'
}

export default FILES_ACTION
